import apiClient from './client';
import type { AdminLoginData, AdminUser } from '../types';

export interface LoginResult {
  requires2FA?: boolean;
  admin?: AdminUser;
}

export async function adminLogin(data: AdminLoginData): Promise<LoginResult> {
  const response = await apiClient.post<LoginResult>('/admin/login', data);
  return response.data;
}

export async function adminVerify2FA(code: string): Promise<AdminUser> {
  const response = await apiClient.post<{ admin: AdminUser }>('/admin/login/2fa', { code });
  return response.data.admin;
}

export async function adminLogout(): Promise<void> {
  await apiClient.post('/admin/logout');
}

export async function getAdminMe(): Promise<AdminUser & { totpEnabled?: boolean }> {
  const response = await apiClient.get<{ admin: AdminUser & { totpEnabled?: boolean } }>('/admin/me');
  return response.data.admin;
}

export async function get2FASetup(): Promise<{ secret: string; qrCodeDataUrl: string }> {
  const response = await apiClient.get('/admin/2fa/setup');
  return response.data;
}

export async function enable2FA(code: string): Promise<void> {
  await apiClient.post('/admin/2fa/enable', { code });
}

export async function disable2FA(code: string): Promise<void> {
  await apiClient.post('/admin/2fa/disable', { code });
}
